import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { ToastrService } from 'ngx-toastr';
import { ModelEditor } from 'src/app/shared/editors/modeleditor';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { ApiService } from 'src/app/Services/api.service';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { LevelEditorComponent } from '../../leveleditor/leveleditor.component';
import { LevelDesignerComponent } from '../../leveldesigner/level-designer/level-designer.component';

@Component({
    selector: 'app-editparkingleveldesign',
    templateUrl: './editparkingleveldesign.component.html',
    styleUrls: ['./editparkingleveldesign.component.scss'],
    standalone: false
})
export class EditparkinglevelDesignComponent extends ModelEditor {
  // @ViewChild("levelMapEditor")
  // public levelMapEditor !: LevelmapeditorComponent;

  @ViewChild("levelDesigner")
  public levelDesigner !: LevelDesignerComponent;

  constructor(private apiService: ApiService, public route: ActivatedRoute, private injector: Injector) {
    super("infrastructure/parkinglots/" + route.snapshot.params["lotid"] + "/leveldesigns", injector);
  }

  public override DefaultModel(): any {
    return { Name: "New Parking Level", Rows: [], Gates: [], Lanes: []};
  }

  public override AfterSave(): void {
    this.ReloadModel();
  }

  public override AfterModelLoaded(): void {
    this.levelDesigner.levelData = this.Form;
    //this.levelDesigner.reloadElements();
  }

  public override BeforeSave(): boolean | void {
    const ErrorList: any[] = [];
    const allChipIds: { chipId: any; label: string }[] = [];
    const spacesMissingNumber: any[] = [];

    const pushIfChip = (item: any, label: string) => {
      if (item != null && item.ChipId != null) {
        allChipIds.push({ chipId: item.ChipId, label });
      }
    };

    (this.Form.get('Rows')?.value ?? []).forEach((row: any) => {
      (row?.Spaces ?? []).forEach((space: any) => {
        pushIfChip(space, 'Space ' + (space?.Name ?? '') + ' ' + (row?.Name ?? ''));
        if (space?.Name == null || String(space.Name).trim() === '') {
          spacesMissingNumber.push({ 'Space': space, 'Row': row });
        }
      });
      (row?.GuidanceLightConfigurations ?? []).forEach((gl: any) => {
        pushIfChip(gl, 'Guidance Light ' + (gl?.Name ?? ''));
      });
    });

    (this.Form.get('GatewayConfigurations')?.value ?? []).forEach((gw: any) => {
      pushIfChip(gw, 'Gateway ' + (gw?.Name ?? ''));
    });
    (this.Form.get('SignConfigurations')?.value ?? []).forEach((sign: any) => {
      pushIfChip(sign, 'Sign ' + (sign?.Name ?? ''));
    });
    (this.Form.get('CarCounterConfigurations')?.value ?? []).forEach((cc: any) => {
      pushIfChip(cc, 'Car Counter ' + (cc?.Name ?? ''));
    });

    const seen = new Set<any>();
    const duplicates = new Set<any>();
    allChipIds.forEach(ref => {
      if (seen.has(ref.chipId)) duplicates.add(ref.chipId);
      else seen.add(ref.chipId);
    });

    duplicates.forEach(duplicate => {
      const names = allChipIds
        .filter(r => r.chipId == duplicate)
        .map(r => '(' + r.label.trim() + ')');
      ErrorList.push('The Chip Id: ' + duplicate + ' is assigned to multiple devices. ' + names.join(','));
    });

    if (spacesMissingNumber.length > 0) {
      const missingRefs = spacesMissingNumber.map(x => '(Row ' + (x.Row.Name ?? '?') + ')').join(',');
      ErrorList.push(spacesMissingNumber.length + ' parking space(s) are missing a Space Number: ' + missingRefs);
    }

    if (ErrorList.length > 0) {
      this.toast.warning(ErrorList.join(","), "Error");
      return false;
    }
  }

  public override Validators(): any {
    return {
      'Name': [Validators.required],
      'PolygonPoints': [Validators.required],
    };
  }

}
